module.exports = __webpack_public_path__ + "img/44.f28a3d41.jpg";